import axios from "axios";

const PROFILE_KEY = "elderra_user_profile";
const REMEMBERED_PHONE_KEY = "elderra_phone";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// The session token itself is an httpOnly cookie set by the backend — it is
// deliberately NOT readable from JavaScript, so an XSS bug can't steal a
// senior's (or an admin's) session. Only the non-secret profile is cached here,
// purely so the UI can render a name without a round trip; the cookie remains
// the single source of truth for what the user is actually allowed to do.
export function getStoredProfile() {
  try {
    return JSON.parse(localStorage.getItem(PROFILE_KEY) || "null");
  } catch {
    return null;
  }
}

export function isAuthed() {
  return !!getStoredProfile();
}

export function setAuth(profile) {
  localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
}

export function clearAuth() {
  localStorage.removeItem(PROFILE_KEY);
}

/** Clears the httpOnly cookie server-side, then the cached profile. */
export async function logout() {
  try {
    await axios.post(`${API}/user/logout`);
  } catch (_) {
    /* the cookie may already be gone — clear locally regardless */
  }
  clearAuth();
}

// Lightweight "remember me by phone" identity for guests (no PIN). Stored so a
// returning guest's saved profile is auto-loaded onto their new chat session.
export function getRememberedPhone() {
  return localStorage.getItem(REMEMBERED_PHONE_KEY);
}

export function setRememberedPhone(phone) {
  if (phone) localStorage.setItem(REMEMBERED_PHONE_KEY, phone);
}

export function clearRememberedPhone() {
  localStorage.removeItem(REMEMBERED_PHONE_KEY);
}
